import 'magnific-popup';

(function ($) {
    var self = {
        selectors: {
            image: '[data-action="mfp-img"]',
            iframe: '[data-action="magnific-iframe"]',
            selectImageButton: '[data-action="popup-image-select"]',
            gallery: '[data-action="mfp-gallery"]'
        },
        initImage: function () {
            $(document).on("click", self.selectors.image, function (e) {
                e.preventDefault();

                $(this).magnificPopup({
                    type: 'image'
                }).magnificPopup('open');
            });
        },
        initSelectImage: function() {
            $(document).on("click", self.selectors.selectImageButton, function (e) {
                e.preventDefault();
                var $this = $(this);
                var topFunction = $this.data('top-action');
                var id = $this.data('id');
                window.top[topFunction](id);
            });
        },
        initIframe: function () {
            $(document).on("click", self.selectors.iframe, function (e) {
                e.preventDefault();

                $(this).magnificPopup({
                    type: 'iframe',
                    mainClass: "mfp-select"
                }).magnificPopup('open');
            });
        },
        initGallery: function () {
            $(self.selectors.gallery).magnificPopup({
                delegate: 'a',
                type: 'image',
                closeOnContentClick: false,
                closeBtnInside: false,
                mainClass: 'mfp-with-zoom mfp-img-mobile',
                allowHTMLInTemplate: false,
                image: {
                    verticalFit: true,
                    titleSrc: function(item) {
                        return item.el.attr('title');
                    }
                },
                gallery: {
                    enabled: true
                },
                zoom: {
                    enabled: true,
                    duration: 300, // don't foget to change the duration also in CSS
                    opener: function(element) {
                        return element.find('img');
                    }
                }
            });
        },
        init: function () {
            $(document).ready(function ($) {
                self.initImage();
                self.initIframe();
                self.initSelectImage();
                self.initGallery();
            })
        }
    };

    self.init();
})(jQuery);